import { useContext } from './context'
import { useVerifyCode } from './useVerifyCode'
import { ShowIf } from '@ztechapps/webui.util'
import { Form, InputGroup, Stack } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'
import { ResendCode } from './ResendCode'

export const VerifyCode = () => {
  const context = useContext()
  const [code, setCode] = context.code
  const [showCodeInput] = context.showCodeInput
  const [destination] = context.destination

  const [onVerifyCode, { loading: verifying }] = useVerifyCode()

  return (
    <div>
      <ShowIf condition={showCodeInput}>
        <Stack gap={2}>
          <h4>
            We send the code to <span className="text-success fst-italic">{destination}</span>
          </h4>
          <div>
            <InputGroup>
              <Form.Control
                type="text"
                id="code"
                required
                value={code}
                name="code"
                onChange={(e) => setCode(e?.target?.value)}
                autoComplete="off"
                placeholder="Code"
                disabled={verifying}
              />
              <BusyButton isBusy={verifying} busyText="Verfying..." onClick={onVerifyCode}>
                Verify
              </BusyButton>
            </InputGroup>
            <Form.Text>
              Enter the 4 digit codes that we sent to your email or phone number and click the verify button. If it is correct, you will be logged in
              automatically.
            </Form.Text>
          </div>

          <ResendCode />
        </Stack>
      </ShowIf>
    </div>
  )
}
